import cimg1 from '../images/category/img-1.jpg'
import cimg2 from '../images/category/img-2.jpg'
import cimg3 from '../images/category/img-3.jpg'
import cimg4 from '../images/category/img-4.jpg'
import cimg5 from '../images/category/img-5.jpg'
import cimg6 from '../images/category/img-6.jpg'



const CoursesCategory = [
   {
      Id: '1',
      cImg: cimg1,
      thumb: 'flaticon-user-experience',
      title: 'UI/UX Design',
      slug: 'UI-UX-Design',
      description: 'We are providing you the best UI/UX design guideline. That help you be professional.',
   },
   {
      Id: '2',
      cImg: cimg2,
      thumb: 'flaticon-megaphone',
      title: 'Digital Marketing',
      slug: 'Digital-Marketing',
      description: 'We are providing you the best Digital Marketing guideline. That help you be professional. '
   },
   {
      Id: '3',
      cImg: cimg3,
      thumb: 'flaticon-code',
      title: 'Development',
      slug: 'Development',
      description: 'We are providing you are the best Development guideline for. That help you be professional.'
   },
   {
      Id: '4',
      cImg: cimg4,
      thumb: 'flaticon-knowledge',
      title: 'Self Improvement',
      slug: 'Self-Improvement',
      description: 'We are providing you the best Self Improvement guideline. That help you be professional.'
   },
   {
      Id: '5',
      cImg: cimg5,
      thumb: 'flaticon-video-lesson',
      title: 'Video Editing',
      slug: 'Video-Editing',
      description: 'We are providing you the best Video Editing guideline for you. That help you be professional.'
   },
   {
      Id: '6',
      cImg: cimg6,
      thumb: 'flaticon-paint-palette',
      title: 'Graphic Design',
      slug: 'Graphic-Design',
      description: 'We are providing you the best Graphic Design guideline. That help you be professional.'
   },

]

export default CoursesCategory;